<template>
    <router-view></router-view>
</template>

<script>
    import PageOptions from '@/Options/PageOptions.js'

    export default {
        metaInfo: {
            titleTemplate: '%s - AHM OIL Dashboard',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
        components: {
        },
        data() {
            return {
                pageOptions: PageOptions,
                alert: this.$store.getters.getAlertStatus,
                alertDuration: 5000,//in ms
            }
        },
        created() {
            this.pageOptions.pageEmpty = false;
        },
        mounted() {
            this.checkAlert();
        },
        watch: {
            '$store.getters.getAlertStatus': function () {
                this.alert = this.$store.getters.getAlertStatus;
                this.checkAlert();
            }
        },
        beforeRouteLeave(to, from, next) {
            PageOptions.pageEmpty = true;
            next();
        },
        methods: {
            checkAlert() {
                setTimeout(() => {
                    if (this.alert.showAlert) this.$store.dispatch('setShowAlert', false);
                }, this.alertDuration);
            }
        }
    }
</script>

<style>
    @font-face {
        font-family: 'Montserrat';
        src: url('/font/Monserrat/Montserrat-Regular.ttf') format('truetype');
    }

    * {
       font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        /* font-weight: bold; */
    }

    /* ALERT MESSAGE STARTS */
    .alertmessage {
        position: fixed;
        top: 10%;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 9999;
        width: 300px;
        text-align: center;
    }

    .alertmessage strong {
        font-size: 150%
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0;
    }

    /* ALERT MESSAGE ENDS */
</style>
    